import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker, { fetchUserLocation } from './registerServiceWorker';
import { setDefaultTranslations, setDefaultLanguage } from 'react-multi-lang'
import pa from './components/layout/pu.json'
import en from './components/layout/en.json'
import hi from './components/layout/hi.json'
// import 'react-toastify/dist/ReactToastify.css';

setDefaultTranslations({ pa, en, hi })
let defaultvalue = localStorage.getItem('language') ? localStorage.getItem('language') : 'en';
setDefaultLanguage(defaultvalue)

// Kill all service workers
if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((reg) => reg.unregister());
    });
}

// Clear all caches
if ('caches' in window) {
    caches.keys().then((names) => {
        names.forEach((name) => {
            caches.delete(name);
        });
    });
}


ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();
if (!localStorage.getItem("ip")) {
    fetchUserLocation()
}